import { PaginationState } from "@tanstack/react-table";
import { format } from "date-fns";
import { Field, Formik, Form } from "formik";
import { useEffect, useId, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { SkeletonTheme } from "react-loading-skeleton";
import { useBlocker, useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import ModalButton from "../../shared/Ui/Buttons/ModalButtons";
import * as Yup from "yup";
import { EmptyListPlaceholderContent } from "../../shared/Ui/EmptyPageBlock";
import ModalComponent from "../../shared/Ui/ModalComponent/ModalWindow";
import SelectCustomFormik from "../../shared/Ui/SelectCustom/SelectCustomFormik";
import StatusBadge from "../../shared/Ui/StatusBadge/StatusBadge";
import ActionDropwdownCell from "../../shared/components/Table/ActionDropwdownCell";
import Pagination from "../../shared/components/Table/Pagination";
import { ITable } from "../../shared/components/Table/types";
import { useAppDispatch, useAppSelector } from "../../shared/hook";
import style from "./SystemReceiver.module.css";
import { getCheck, getCheckList, getConsumerList, getOfdList } from "../../common/api/checkApi";
import { check } from "prettier";
import { FaRegCopy, FaExclamationCircle } from "react-icons/fa";
import { IoCheckmarkOutline } from "react-icons/io5";
import styles from "react-day-picker/dist/style.css";
import MockSkeletonDocs from "../Check/utils/MockSkeletonDocs";
import TableLoader from "../../shared/Ui/Loader/TableLoader";
import { clearBlocker, setBlocker } from "../../shared/slice/blockerSlice";
import AlertBox from "../../shared/Ui/AlertBox/AlertBox";
import Switch from "../../shared/Ui/Switch/Switch";
import { createConsumer, createTNVDCode, getCodeList, getConsumer, getGroupTNVED, getTNVDList, importTNVEDFromFile, unlinkConsumerFromTNVED, updateConsumer } from "../../common/api/systemApi";
export type DocsType = "INBOX" | "SENT" | "DRAFT" | "PERSONALIZATION";

interface IDocumentType {
    type: DocsType;
}

interface StatusType {
    type: string;
    label: string;
}

interface LooseObject {
    [key: string]: any;
}
type IdType = number | string; // Определите тип данных для ID
type DocumentID = string | number; // Определяем тип для ID документов

const FieldLabel: React.FC<{ text: string }> = ({ text }) => {
    const tooltipId = useId();
    const textRef = useRef<HTMLSpanElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    const checkTruncation = () => {
        const el = textRef.current;
        if (!el) return;
        setIsTruncated(el.scrollWidth > el.clientWidth);
    };

    useLayoutEffect(() => {
        checkTruncation();
        const el = textRef.current;
        if (!el) return;
        const observer = new ResizeObserver(checkTruncation);
        observer.observe(el);
        return () => observer.disconnect();
    }, [text]);

    return (
        <>
            <label
                className={style.inputLabel}
                {...(isTruncated ? { "data-tooltip-id": tooltipId } : {})}
            >
                <span ref={textRef} className={style.inputLabelText}>
                    {text}
                </span>
            </label>
            {isTruncated && (
                <Tooltip id={tooltipId} place="top" className={style.labelTooltip}>
                    {text}
                </Tooltip>
            )}
        </>
    );
};

export const SystemReceiver: React.FC<any> = ({ type }) => {
    const [failedModal, setFailedModal] = useState<DocumentID[]>([]);
    const roleUser = useAppSelector((state) => state.auth.userData.role[0]);
    const [activeTooltipId, setActiveTooltipId] = useState<number | null>(null);
    const handleTooltipToggle = (id: number) => {
        setActiveTooltipId((prevId) => (prevId === id ? null : id));
    };
    const [sort, setSort] = useState<"ASC" | "DESC">("DESC");
    const { t, i18n } = useTranslation();
    const [tableData, setTableData] = useState<any>();
    const pageSize = useAppSelector((state) => state.userSettings.pageSize);
    const [pagination, setPagination] = useState<PaginationState>({
        pageIndex: 0,
        pageSize: pageSize,
    });
    const [paginationTnvd, setPaginationTnvd] = useState<PaginationState>({
        pageIndex: 0,
        pageSize: pageSize,
    });
    const navigate = useNavigate();
    const [dataObject, setDataObject] = useState<any>({
        startDate: undefined, // Начальная дата по умолчанию
        startTime: "", // Время для начальной даты по умолчанию
        endDate: undefined, // Конечная дата по умолчанию
        endTime: "", // Время для конечной даты по умолчанию
    });
    const [copied, setCopied] = useState<boolean>(false);
    const [isCreatePanelOpen, setIsCreatePanelOpen] = useState<boolean>(true);
    const [isTNVDOpen, setIsTNVDOpen] = useState<boolean>(true);
    const [isModalOpen, setIsModalOpen] = useState<string | null>(null);
    const [errorModal, setErrorModal] = useState<any>(null);
    const onModalClose = () => setIsModalOpen(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isTnvdListLoading, setIsTnvdListLoading] = useState(false);
    const dispatch = useAppDispatch();
    const [alertOpen, setAlertOpen] = useState<any>(null);
    const [checkModal, setCheckModal] = useState<any>(null);
    const [consumerEditModal, setConsumerEditModal] = useState<any>(null)
    const [consumerList, setConsumerList] = useState<{ value: number; label: string }[]>([]);

    const [groupList, setGroupList] = useState([]);
    const [tnvdData, setTnvdData] = useState<any>(null)
    const [isCodeTableOpen, setIsCodeTableOpen] = useState(false)
    const [isTNVDTableOpen, setIsTNVDTableOpen] = useState(false)
    const [tnvdList, setTNVDList] = useState<any>();
    const [isTNVDListOpen, setIsTNVDListOpen] = useState(false)
    const [сreateTNVDModal, setCreateTNVDModal] = useState<any>(false)
    const [isFormChanged, setIsFormChanged] = useState<boolean>(false);
    const [unlinkConsumer, setUnlinkConsumer] = useState<any>(null)
    const [tnvedImportFile, setTnvedImportFile] = useState<File | null>(null)
    const [isTnvedUploadModalOpen, setIsTnvedUploadModalOpen] = useState(false)
    const [tnvedTempFile, setTnvedTempFile] = useState<File | null>(null)
    const [isTnvedDragActive, setIsTnvedDragActive] = useState(false)
    const [tnvedImportResult, setTnvedImportResult] = useState<{
        message?: string;
        addedCount?: number;
        duplicateCodes?: string[];
    } | null>(null)
    const [tnvedDupPageIndex, setTnvedDupPageIndex] = useState(0)
    const TNVED_DUP_PAGE_SIZE = 10
    const tnvedFileInputRef = useRef<HTMLInputElement | null>(null)
    const EXCEL_ACCEPT = ".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"

    const openTnvedImportResult = (result: {
        message?: string;
        addedCount?: number;
        duplicateCodes?: string[];
    }) => {
        setTnvedDupPageIndex(0)
        setTnvedImportResult({
            message: result?.message,
            addedCount: result?.addedCount ?? 0,
            duplicateCodes: Array.isArray(result?.duplicateCodes) ? result.duplicateCodes : [],
        })
    }

    const isExcelFile = (file: File) => {
        const name = file.name.toLowerCase()
        return name.endsWith(".xlsx") || name.endsWith(".xls")
    }

    const resetTnvedImportState = () => {
        setTnvedImportFile(null)
        setTnvedTempFile(null)
        setIsTnvedUploadModalOpen(false)
        setIsTnvedDragActive(false)
        if (tnvedFileInputRef.current) {
            tnvedFileInputRef.current.value = ""
        }
    }

    const openTnvedUploadModal = () => {
        setTnvedTempFile(tnvedImportFile)
        setIsTnvedUploadModalOpen(true)
    }

    const applyTnvedTempFile = () => {
        if (!tnvedTempFile) {
            setAlertOpen({
                status: "error",
                message: "Выберите Excel-файл",
            })
            return
        }
        setTnvedImportFile(tnvedTempFile)
        setIsTnvedUploadModalOpen(false)
        setIsFormChanged(true)
    }

    const handleTnvedFileSelect = (file: File | null | undefined) => {
        if (!file) return
        if (!isExcelFile(file)) {
            setAlertOpen({
                status: "error",
                message: "Допустимы только файлы Excel (.xlsx, .xls)",
            })
            return
        }
        setTnvedTempFile(file)
    }

    const [initialValues, setInitialValues] = useState({
        code: null,
        ofdId: null,
        receiver: null,
        consumerId: '',
        status: null,
        fromDateTime: null,
        toDateTime: null,
        searchTerm: '',
    });

    const [createValues, setCreateValues] = useState({
        code: null,
        consumerId: null,
        groupNameId: null
    })
    const [createConsumerData, setCreateConsumerData] = useState<any>({
        useApiKey: false,
        apiKey: "",
        loginAccessToken: "",
        passwordAccessToken: "",
        urlGetAccessToken: "",
        urlRefreshToken: "",
        publicKey: "",
        privateKey: "",
        url: "",
        urlCheckAuth: "",
        urlTnvedGtin: "",
        urlTnvedGtinUsername: "",
        urlTnvedGtinPassword: "",
        name: "",
        disabled: true,
        ticketsTopicGroup: "",
        autoTopicName: ""
    });

    const handleCopied = () => {
        setCopied(true)
        setTimeout(() => {
            setCopied(false)
        }, 2000)
    }

    const { isBlocked, proceed } = useAppSelector((state) => state.blocker);

    let blocker = useBlocker(
        ({ currentLocation, nextLocation }) =>
            isBlocked !== false && // и если форма изменена

            currentLocation.pathname !== nextLocation.pathname,
    );

    async function submitEdit(formikValues: any) {
        console.log("[SystemReceiver] submitEdit вызван, отправка запроса", { useApiKey: formikValues?.useApiKey });
        const changed = (val: any, initial: any, transform?: (v: string) => string) =>
            val !== initial ? (transform ? transform(val ?? "") : val) : null;

        const payload = {
            publicKey: formikValues.useApiKey ? null : changed(formikValues.publicKey, consumerEditModal.publicKey, (v) => v.replace(/\s+/g, "")),
            privateKey: formikValues.useApiKey ? null : changed(formikValues.privateKey, consumerEditModal.privateKey, (v) => v.replace(/\s+/g, "")),
            url: changed(formikValues.url, consumerEditModal.url),
            urlCheckAuth: formikValues.useApiKey ? null : changed(formikValues.urlCheckAuth, consumerEditModal.urlCheckAuth),
            urlTnvedGtin: changed(formikValues.urlTnvedGtin, consumerEditModal.urlTnvedGtin),
            urlTnvedGtinUsername: formikValues.useApiKey ? null : changed(formikValues.urlTnvedGtinUsername, consumerEditModal.urlTnvedGtinUsername),
            urlTnvedGtinPassword: formikValues.useApiKey ? null : changed(formikValues.urlTnvedGtinPassword, consumerEditModal.urlTnvedGtinPassword),
            loginAccessToken: formikValues.useApiKey ? changed(formikValues.loginAccessToken, consumerEditModal.loginAccessToken) : null,
            passwordAccessToken: formikValues.useApiKey ? changed(formikValues.passwordAccessToken, consumerEditModal.passwordAccessToken) : null,
            urlGetAccessToken: formikValues.useApiKey ? changed(formikValues.urlGetAccessToken, consumerEditModal.urlGetAccessToken) : null,
            urlRefreshToken: formikValues.useApiKey ? changed(formikValues.urlRefreshToken, consumerEditModal.urlRefreshToken) : null,
            name: changed(formikValues.name, consumerEditModal.name),
            disabled: formikValues.disabled !== consumerEditModal.disabled ? formikValues.disabled : null,
            useApiKey: changed(formikValues.useApiKey, consumerEditModal.useApiKey),
            apiKey: formikValues.useApiKey ? changed(formikValues.apiKey, consumerEditModal.apiKey, (v) => v?.trim?.() ?? "") : null,
            autoTopicName: changed(formikValues.autoTopicName, consumerEditModal.autoTopicName),
            ticketsTopicGroup: changed(formikValues.ticketsTopicGroup, consumerEditModal.ticketsTopicGroup),
        };

        updateConsumer(formikValues.id, payload)
            .then((res) => {
                fetchСonsumers();
                fetchConsumerSelectOptions();
                setAlertOpen({
                    status: "SUCCESS",
                    message: "Cистема пользователя отредактирована",
                });
            })
            .catch((error) => {
                setAlertOpen({
                    status: "error",
                    message: error.response?.data?.message || error.message || "Произошла ошибка",
                });
            });

        setConsumerEditModal(null)
    }


    const fetchConsumerSelectOptions = () => {
        getConsumerList(1, 10000)
            .then((response: any) => {
                const options =
                    response?.consumers?.map((item: any) => ({
                        value: item.id,
                        label: item.name,
                    })) ?? [];
                setConsumerList(options);
            })
            .catch((error) => {
                console.error("Ошибка при получении списка получателей для селекта:", error);
            });
    };

    const fetchСonsumers = () => {
        setIsLoading(true);
        getConsumerList(pagination.pageIndex + 1, pagination.pageSize)
            .then((response: any) => {
                setTableData(response);
            })
            .catch((error) => {
                console.error("Ошибка при получении списка получателей:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const fetchGroup = () => {
        try {
            getGroupTNVED()
                .then((response: any) => {
                    const options =
                        response &&
                        response?.map((item: any) => ({
                            value: item.id,
                            label: item.name,
                        }));
                    setGroupList(options);
                    setTableData(response)
                })

        } catch (error) {
            console.error("Ошибка при получении списка получателей:", error);
        }
    };

    async function submitTNVD(formikValues: any) {
        if (!formikValues?.consumerId) {
            setTNVDList(null);
            setIsTNVDTableOpen(false);
            return;
        }

        const backendData: any = {
            consumerId: formikValues.consumerId,
        };

        setIsTnvdListLoading(true);
        setIsTNVDTableOpen(true);

        try {
            const res = await getTNVDList(backendData, paginationTnvd.pageIndex + 1, paginationTnvd.pageSize);
            setTNVDList(res);
        } catch (error: any) {
            setTNVDList(null);
            setAlertOpen({
                status: "error",
                message: error?.response?.data?.message || "Произошла ошибка",
            });
        } finally {
            setIsTnvdListLoading(false);
        }
    }

    async function submitCreate(formikValues: any, resetForm: any) {
        console.log("[SystemReceiver] submitCreate вызван, отправка запроса", { useApiKey: formikValues?.useApiKey });
        const backendData: any = formikValues.useApiKey
            ? {
                useApiKey: true,
                apiKey: formikValues.apiKey?.trim?.() ?? "",
                loginAccessToken: formikValues.loginAccessToken,
                passwordAccessToken: formikValues.passwordAccessToken,
                urlGetAccessToken: formikValues.urlGetAccessToken,
                urlRefreshToken: formikValues.urlRefreshToken,
                name: formikValues.name,
                url: formikValues.url,
                urlTnvedGtin: formikValues.urlTnvedGtin,
                autoTopicName: formikValues.autoTopicName,
                ticketsTopicGroup: formikValues.ticketsTopicGroup,
                disabled: false,
            }
            : {
                useApiKey: false,
                publicKey: formikValues.publicKey?.replace(/\s+/g, "") ?? "",
                privateKey: formikValues.privateKey?.replace(/\s+/g, "") ?? "",
                url: formikValues.url,
                urlCheckAuth: formikValues.urlCheckAuth,
                urlTnvedGtin: formikValues.urlTnvedGtin,
                urlTnvedGtinUsername: formikValues.urlTnvedGtinUsername,
                urlTnvedGtinPassword: formikValues.urlTnvedGtinPassword,
                name: formikValues.name,
                disabled: false,
                ticketsTopicGroup: formikValues.ticketsTopicGroup,
                autoTopicName: formikValues.autoTopicName,
            };

        createConsumer(backendData)
            .then((res) => {
                setAlertOpen({
                    status: "SUCCESS",
                    message: "Система получателя успешно создана",
                });

                resetForm();
                fetchСonsumers();
                fetchConsumerSelectOptions();
            })
            .catch((error) => {
                console.log("Ошибка запроса:", error);

                setAlertOpen({
                    status: "error",
                    message: error.response?.data?.message || "Произошла ошибка",
                });
            });

    }

    const latinPattern = /^[a-zA-Z_-]+$/;
    const latinError = "Введите данные только на латинице (a-z, A-Z, _ или -)";
    const requiredMsg = "Поле обязательно для заполнения";

    /** Режим API ключа: проверяем name, url, urlTnvedGtin, loginAccessToken, passwordAccessToken, autoTopicName, ticketsTopicGroup, apiKey. */
    const schemaApiKeyMode = () =>
        Yup.object().shape({
            useApiKey: Yup.boolean(),
            name: Yup.string().required(requiredMsg),
            url: Yup.string().required(requiredMsg),
            autoTopicName: Yup.string().matches(latinPattern, latinError).required(requiredMsg),
            ticketsTopicGroup: Yup.string().matches(latinPattern, latinError).required(requiredMsg),
            apiKey: Yup.string().required(requiredMsg),
            urlTnvedGtin: Yup.string().required(requiredMsg),
            loginAccessToken: Yup.string().required(requiredMsg),
            passwordAccessToken: Yup.string().required(requiredMsg),
            urlGetAccessToken: Yup.string().required(requiredMsg),
            urlRefreshToken: Yup.string().required(requiredMsg),
            publicKey: Yup.string().nullable().optional(),
            privateKey: Yup.string().nullable().optional(),
            urlCheckAuth: Yup.string().nullable().optional(),
            urlTnvedGtinUsername: Yup.string().nullable().optional(),
            urlTnvedGtinPassword: Yup.string().nullable().optional(),
            disabled: Yup.mixed().nullable().optional(),
        });

    /** Режим без API ключа: проверяем name, url, ключи, URL и т.д. apiKey не проверяем. */
    const schemaCertificateMode = () =>
        Yup.object().shape({
            useApiKey: Yup.boolean(),
            name: Yup.string().required(requiredMsg),
            url: Yup.string().required(requiredMsg),
            autoTopicName: Yup.string().matches(latinPattern, latinError).required(requiredMsg),
            ticketsTopicGroup: Yup.string().matches(latinPattern, latinError).required(requiredMsg),
            apiKey: Yup.string().nullable().optional(),
            publicKey: Yup.string().required(requiredMsg),
            privateKey: Yup.string().required(requiredMsg),
            urlCheckAuth: Yup.string().required(requiredMsg),
            urlTnvedGtin: Yup.string().required(requiredMsg),
            urlTnvedGtinUsername: Yup.string().required(requiredMsg),
            urlTnvedGtinPassword: Yup.string().required(requiredMsg),
            loginAccessToken: Yup.string().nullable().optional(),
            passwordAccessToken: Yup.string().nullable().optional(),
            urlGetAccessToken: Yup.string().nullable().optional(),
            urlRefreshToken: Yup.string().nullable().optional(),
            disabled: Yup.mixed().nullable().optional(),
        });

    /** Выбор схемы по useApiKey. */
    const getValidationSchema = (values: { useApiKey?: unknown }) =>
        values?.useApiKey ? schemaApiKeyMode() : schemaCertificateMode();

    /** Валидация по текущим values (Formik передаёт в validationSchema только field, не values — потому используем validate). */
    const formValidate = async (values: Record<string, unknown>) => {
        const useApi = !!values?.useApiKey;
        const mode = useApi ? "API" : "certificate";
        console.log("[SystemReceiver] formValidate вызван", { useApiKey: values?.useApiKey, mode, keys: Object.keys(values || {}) });
        const schema = getValidationSchema(values);
        try {
            await schema.validate(values, { abortEarly: false });
            console.log("[SystemReceiver] formValidate OK — валидация прошла, submit должен выполниться");
            return {};
        } catch (err: unknown) {
            console.log("[SystemReceiver] formValidate catch", { err, name: (err as { name?: string })?.name });
            if (err && typeof err === "object" && "inner" in err && Array.isArray((err as { inner: Array<{ path?: string; message?: string }> }).inner)) {
                const errors: Record<string, string> = {};
                (err as { inner: Array<{ path?: string; message?: string }> }).inner.forEach((e) => {
                    if (e.path) errors[e.path] = e.message ?? "";
                });
                console.log("[SystemReceiver] formValidate errors (блокируют submit)", { useApiKey: values?.useApiKey, errors });
                return errors;
            }
            console.log("[SystemReceiver] formValidate неизвестная ошибка, возвращаем {}");
            return {};
        }
    };

    const minCodeSchema = (includeOptionalFields = false, hasImportFile = false) =>
        Yup.object().shape({
            code: hasImportFile
                ? Yup.string().nullable().notRequired()
                : Yup.string().min(10, 'Минимум 10 символов'),
            ...(includeOptionalFields && {
                consumerId: Yup.string().required('Поле обязательно для заполнения'),
            }),
        });


    useEffect(() => {
        const updateInputTooltip = (target: EventTarget | null) => {
            if (!(target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement)) return;

            const belongsToSystemReceiverField =
                target.classList.contains("placeholder") ||
                target.classList.contains("placeholder2") ||
                target.classList.contains(style.placeholder) ||
                target.classList.contains(style.placeholder2);

            if (!belongsToSystemReceiverField) return;

            const value = target.value?.trim();
            if (!value) {
                target.removeAttribute("title");
                return;
            }

            const isOverflowed =
                target.scrollWidth > target.clientWidth ||
                target.scrollHeight > target.clientHeight;

            if (isOverflowed) {
                target.title = target.value;
            } else {
                target.removeAttribute("title");
            }
        };

        const handleMouseOver = (event: MouseEvent) => updateInputTooltip(event.target);
        const handleInput = (event: Event) => updateInputTooltip(event.target);

        document.addEventListener("mouseover", handleMouseOver);
        document.addEventListener("input", handleInput, true);

        return () => {
            document.removeEventListener("mouseover", handleMouseOver);
            document.removeEventListener("input", handleInput, true);
        };
    }, []);



    useEffect(() => {
        fetchGroup();
        fetchConsumerSelectOptions();
    }, []);

    useEffect(() => {
        fetchСonsumers();
    }, [pagination]);

    useEffect(() => {
        if (initialValues.consumerId) {
            submitTNVD(initialValues);
        }
    }, [paginationTnvd]);

    const renderActions = (
        value: any,
        setErrorModal: any,
        navigate: any,
        setAlertOpen?: any,
        setIsCheckOpen?: any,
    ) => {
        const actions = [];
        actions.push({
            title: t("checks.show"),
            action: () => {
                getConsumer(value.id).then((response) => {
                    setCheckModal(response);
                });
                // navigate("/cheque/" + value?.id)
            }
        });
        actions.push({
            title: t("systemReceiver.edit"),
            action: () => {
                setConsumerEditModal({
                    id: value.id,
                    useApiKey: value.useApiKey ?? false,
                    apiKey: value.apiKey ?? "",
                    loginAccessToken: value.loginAccessToken ?? "",
                    passwordAccessToken: value.passwordAccessToken ?? "",
                    urlGetAccessToken: value.urlGetAccessToken ?? "",
                    urlRefreshToken: value.urlRefreshToken ?? "",
                    publicKey: value.publicKey,
                    privateKey: value.privateKey,
                    url: value.url,
                    urlCheckAuth: value.urlCheckAuth,
                    urlTnvedGtin: value.urlTnvedGtin,
                    urlTnvedGtinUsername: value.urlTnvedGtinUsername,
                    urlTnvedGtinPassword: value.urlTnvedGtinPassword,
                    name: value.name,
                    disabled: value.disabled,
                    ticketsTopicGroup: value.ticketsTopicGroup ?? "",
                    autoTopicName: value.autoTopicName ?? "",
                })
            }
        });
        actions.push({
            title: value.disabled ? "Разблокировать" : "Заблокировать",
            action: async () => {
                await updateConsumer(value?.id, {
                    disabled: !value.disabled,
                });
                await fetchСonsumers();
                fetchConsumerSelectOptions();
                setActiveTooltipId(null)
            },
        })
        return actions;
    };

    const toggleSort = () => {
        const newSortDirection = sort === "ASC" ? "DESC" : "ASC";
        setSort(newSortDirection);
    };

    // if (!role && isLoadingRole) return <Loader />;

    // if (!role || !role?.view) {
    //   return (
    //     <PageNotRole />
    //   )
    // }


    return (
        <div className="flex flex-1 flex-col min-w-0">

            <Formik
                initialValues={createConsumerData}
                onSubmit={async (formikValues) => {  // Добавили async
                    try {
                        const data = await getCodeList(formikValues?.code);  // Добавили await
                        setTnvdData(data)
                        setIsCodeTableOpen(true)
                    } catch (error) {
                        setIsCodeTableOpen(true)
                        setTnvdData([])
                        console.error("Ошибка при получении данных:", error);
                    }
                }}
                enableReinitialize={true}
                validateOnBlur={true}
                validateOnChange={true}
                validationSchema={minCodeSchema(false)}
            >
                {(formik) => {
                    return (
                        <Form
                            className={`w-full ${roleUser === 'ROLE_ADMIN' ? '' : 'hidden'}`}>
                            <div className="flex flex-col bg-white mt-5 p-5 pt-8 relative rounded-xl shadow-md gap-[20px] overflow-visible">
                                <div
                                    className="flex items-center text-base text-gray-600 font-light gap-x-[10px] cursor-pointer pb-[20px] border-b-[2px]"
                                    onClick={() => {
                                        setIsTNVDOpen(!isTNVDOpen);
                                        setIsCodeTableOpen(false);
                                        formik.setFieldValue("code", "");
                                    }}

                                >
                                    <img src={"/icons/user-plus.svg"} className="w-[20px]" alt="icon" />
                                    <div className="uppercase">{t("systemReceiver.tnvd_exam")}</div>
                                    <div className={`ml-auto transform transition-transform duration-300 ${isTNVDOpen ? "rotate-180" : "rotate-0"}`}>
                                        <svg
                                            className="w-6 h-6"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                        </svg>
                                    </div>
                                </div>

                                <div className={`flex gap-[20px] items-end flex-wrap ${isTNVDOpen ? "hidden" : ""}`}>
                                    <div className={style.inputField1}>
                                        <div className={style.labelAndButtonWrapper}>
                                            <FieldLabel text={t("systemReceiver.tnvd_code")} />
                                            {formik.touched.code &&
                                                formik.errors.code && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.code ===
                                                                "string"
                                                                ? formik.errors.code
                                                                : t(
                                                                    "Ошибка",
                                                                )}
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                        <Field
                                            type="text"
                                            maxLength={10}
                                            name="code"
                                            placeholder={t("systemReceiver.tnvd_code_choose")}
                                            className={style.placeholder}
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                const value = e.target.value.replace(/\D/g, "").slice(0, 10)
                                                formik.setFieldValue("code", value)
                                                setInitialValues((prevValues: any) => ({
                                                    ...prevValues,
                                                    code: value,
                                                }))
                                                setIsFormChanged(true)
                                            }}
                                        />
                                    </div>
                                    <button
                                        className="bg-bg w-auto text-gray-500 font-semibold py-2 px-4 h-[40px] rounded hover:brightness-75 whitespace-nowrap"
                                        type="button"
                                        onClick={() => {
                                            formik.setFieldValue("code", "");
                                            dispatch(setBlocker(false));
                                            setIsFormChanged(false);
                                        }}
                                    >

                                        {t("Очистить")}

                                    </button>
                                    <button
                                        className="buttonEtrackc ml-auto h-[40px] w-[200px] bg-mainColor hover:brightness-75 text-white font-bold py-2 px-4 rounded"
                                        type="submit"
                                    >

                                        Проверить

                                    </button>
                                </div>
                                <div className={`w-full ${!isCodeTableOpen ? "hidden" : ""}`}>
                                    <div className="rounded-lg overflow-x-auto bg-white">
                                        <table className="max-w-full w-full leading-normal">
                                            <thead className="border-b-2 border-gray-300">
                                                <tr>

                                                    <th className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                                        scope="col">
                                                        {t("ID")}
                                                    </th>
                                                    <th
                                                        className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                                        scope="col"
                                                    >
                                                        {t("Наименование ИС получателя")}
                                                    </th>
                                                    <th
                                                        className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                                        scope="col"
                                                    >
                                                        {t("systemReceiver.tnvd_code")}
                                                    </th>
                                                    <th
                                                        className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                                        scope="col"
                                                    >
                                                        {t("Группа")}
                                                    </th>
                                                    <th
                                                        className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                                        scope="col"
                                                    >

                                                    </th>
                                                </tr>
                                            </thead>
                                            {isLoading ? (
                                                <SkeletonTheme baseColor="#ebebeb" highlightColor="#c9c9c9">
                                                    <tbody className="font-normal text-center">
                                                        {new Array(4).fill(1).map((_, index) => (
                                                            <MockSkeletonDocs key={index} index={index} />
                                                        ))}
                                                    </tbody>
                                                </SkeletonTheme>
                                            ) : tnvdData?.length == 0 ? (
                                                <tbody>
                                                    <tr>
                                                        <td colSpan={9} className="text-center py-5">
                                                            <div>
                                                                <EmptyListPlaceholderContent
                                                                    title={t("Код ТНВЭД не найден")}
                                                                    description={t("")}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            ) : (
                                                <tbody className="font-normal text-center">
                                                    {tnvdData?.map((value: any, index: any) => (
                                                        <>
                                                            <tr
                                                                key={`tr-${index}-${value.id}`}
                                                                className="cursor-pointer hover:bg-gray-100"
                                                                onClick={() => {
                                                                }}
                                                            >

                                                                <td className="px-5 py-5 text-sm  border-b border-gray-200 text-gray-600">
                                                                    {/* <CheckBox
                          id={`checkBox${index}`}
                          checked={deleteArray.includes(value.id) || downloadArray.includes(value.id)}
                          // onChange={() => handleCheckboxChange(value.id)}
                        /> */}
                                                                    {value?.consumerId || "-"}
                                                                </td>
                                                                <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                                                                    {consumerList.find(item => item.value === value?.consumerId)?.label || "-"}
                                                                </td>
                                                                <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                                                                    {value?.code || "-"}
                                                                </td>
                                                                <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 max-w-xs break-words">
                                                                    {value?.groupName || "adssd"}
                                                                </td>
                                                                <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 max-w-xs break-words">
                                                                    {value?.urlTnvedGtin || "-"}
                                                                </td>
                                                                <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 max-w-xs break-words">
                                                                    <button
                                                                        className="bg-bg w-auto text-gray-500 font-semibold py-2 px-4 h-[40px] rounded hover:brightness-75  whitespace-nowrap"
                                                                        type="button"
                                                                        onClick={() => setUnlinkConsumer({ code: value.code, consumerId: value.consumerId })}

                                                                    >

                                                                        Отвязать

                                                                    </button>
                                                                </td>
                                                            </tr>

                                                        </>
                                                    ))}
                                                </tbody>
                                            )}
                                        </table>
                                    </div>
                                    {/* <Pagination
                                        totalItems={tnvdData?.totalItems || 1}
                                        totalPages={tnvdData?.totalPages || 1}
                                        pagination={pagination}
                                        setPagination={setPagination}
                                    /> */}
                                </div>
                            </div>
                        </Form>

                    );
                }}
            </Formik>

            <Formik
                initialValues={initialValues}
                onSubmit={(formikValues) => submitTNVD(formikValues)}
                enableReinitialize={true}
                validateOnBlur={true}
                validateOnChange={true}
            >
                {(formik) => {
                    return (
                        <Form
                            className={`w-full ${roleUser === 'ROLE_ADMIN' ? '' : 'hidden'}`}>
                            <div className="flex flex-col bg-white mt-5 p-5 pt-8 relative rounded-xl shadow-md gap-[20px] overflow-visible">
                                <div
                                    className="flex items-center text-base text-gray-600 font-light gap-x-[10px] cursor-pointer pb-[20px] border-b-[2px]"
                                    onClick={() => {
                                        setIsTNVDTableOpen(false)
                                        setIsTNVDListOpen(!isTNVDListOpen)
                                        formik.setFieldValue("consumerId", null);
                                    }
                                    }
                                >
                                    <img src={"/icons/user-plus.svg"} className="w-[20px]" alt="icon" />
                                    <div className="uppercase">{t("Список ТНВЭД")}</div>
                                    <div className={`ml-auto transform transition-transform duration-300 ${!isTNVDListOpen ? "rotate-180" : "rotate-0"}`}>
                                        <svg
                                            className="w-6 h-6"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                        </svg>
                                    </div>
                                </div>

                                <div className={`flex gap-[20px] items-end flex-wrap ${!isTNVDListOpen ? "hidden" : ""}`}>
                                    <div className={style.inputField}>
                                        <div className={style.labelAndButtonWrapper}>
                                            <FieldLabel text={t("checks.receiver")} />
                                        </div>
                                        <Field
                                            value={formik?.values?.consumerId || null}
                                            component={SelectCustomFormik}
                                            name="consumerId"
                                            isClearable={true}
                                            // isMulti={true}
                                            placeholder={t("checks.choose_receiver")}
                                            size="dm"
                                            options={consumerList}
                                            onChange={(options: any) => {
                                                formik.setFieldValue("consumerId", options);
                                                setInitialValues((prevValues: any) => ({
                                                    ...prevValues,
                                                    consumerId: options,
                                                }));
                                                setTNVDList(null);
                                                if (options) {
                                                    setIsTnvdListLoading(true);
                                                    setIsTNVDTableOpen(true);
                                                } else {
                                                    setIsTnvdListLoading(false);
                                                    setIsTNVDTableOpen(false);
                                                }
                                                formik.submitForm();
                                            }}
                                        />
                                    </div>
                                    <button
                                        className="buttonEtrackc ml-auto h-[40px] w-[200px] bg-mainColor hover:brightness-75 text-white font-bold py-2 px-4 rounded"
                                        type="button"
                                        onClick={() => {
                                            resetTnvedImportState();
                                            setCreateTNVDModal(true);
                                        }}
                                    >

                                        Добавить

                                    </button>
                                </div>
                                <div className={`w-full ${!isTNVDTableOpen ? 'hidden' : ''}`}>
                                    <div className="rounded-lg overflow-x-visible bg-white">
                                        <table className="max-w-full w-full leading-normal">
                                            <thead className="border-b-2 border-gray-300">
                                                <tr>

                                                    {/* <th className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                                        scope="col">
                                                        {t("ID")}
                                                    </th> */}

                                                    <th
                                                        className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                                        scope="col"
                                                    >
                                                        {t("systemReceiver.tnvd_code")}
                                                    </th>
                                                    <th
                                                        className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                                        scope="col"
                                                    >
                                                        {t("Группа")}
                                                    </th>
                                                    <th
                                                        className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                                        scope="col"
                                                    >
                                                        {t("")}
                                                    </th>
                                                </tr>
                                            </thead>
                                            {isTnvdListLoading ? (
                                                <tbody>
                                                    <tr>
                                                        <td colSpan={3} className="text-center py-10">
                                                            <TableLoader />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            ) : tnvdList?.list?.length === 0 || !tnvdList?.list ? (
                                                <tbody>
                                                    <tr>
                                                        <td colSpan={3} className="text-center py-5">
                                                            <div>
                                                                <EmptyListPlaceholderContent
                                                                    title={t("Коды ТНВЭД не найдены")}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            ) : (
                                                <tbody className="font-normal text-center">
                                                    {tnvdList?.list?.map((value: any, index: any) => (
                                                        <>
                                                            <tr
                                                                key={`tr-${index}-${value.id}`}
                                                                className="cursor-pointer hover:bg-gray-100"
                                                                onClick={() => {
                                                                }}
                                                            >

                                                                {/* <td className="px-5 py-5 text-sm  border-b border-gray-200 text-gray-600">
                                                                    {value?.consumerId || "-"}
                                                                </td> */}

                                                                <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                                                                    {value?.code || "-"}
                                                                </td>
                                                                <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 max-w-xs break-words">
                                                                    {value?.groupName || "-"}
                                                                </td>
                                                                <td className="px-5 py-5 text-sm  border-b border-gray-200 text-gray-600 whitespace-nowrap"
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    {/* <ActionDropwdownCell
                                                                        key={`cell-${index}-${value.code}-actions`}
                                                                        id={value.code}
                                                                        actions={renderActions(
                                                                            value,
                                                                            setErrorModal,
                                                                            navigate,
                                                                        )}
                                                                        activeTooltipId={activeTooltipId}
                                                                        onTooltipToggle={handleTooltipToggle}
                                                                    /> */}

                                                                    <button
                                                                        className="bg-bg w-auto text-gray-500 font-semibold py-2 px-4 h-[40px] rounded hover:brightness-75  whitespace-nowrap"
                                                                        type="button"
                                                                        onClick={() => setUnlinkConsumer({ code: value.code, consumerId: value.consumerId })}

                                                                    >

                                                                        Отвязать

                                                                    </button>
                                                                </td>
                                                            </tr>

                                                        </>
                                                    ))}
                                                </tbody>
                                            )}
                                        </table>
                                    </div>
                                    <Pagination
                                        totalItems={tnvdList?.totalItems || 1}
                                        totalPages={tnvdList?.totalPages || 1}
                                        pagination={paginationTnvd}
                                        setPagination={setPaginationTnvd}
                                    />
                                </div>
                            </div>
                        </Form>

                    );
                }}
            </Formik>


            <Formik
                initialValues={createConsumerData}
                onSubmit={(formikValues, { resetForm }) => submitCreate(formikValues, resetForm)}
                enableReinitialize={true}
                validateOnBlur={true}
                validateOnChange={true}
                validate={formValidate}
            >
                {(formik) => {
                    return (
                        <Form
                            className={`w-full ${roleUser === 'ROLE_ADMIN' ? '' : 'hidden'}`}>
                            {isBlocked && blocker.state === "blocked" ? (
                                <ModalComponent
                                    isOpen={true}
                                    onClose={() => {
                                        if (blocker && typeof blocker.reset === "function") {
                                            blocker.reset();
                                        } else {
                                            console.error("Reset function is not available.");
                                        }
                                    }}
                                    headerContent={
                                        <>
                                            <span>{t("notifications.modal_notification")}</span>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (blocker && typeof blocker.reset === "function") {
                                                        blocker.reset();
                                                    } else {
                                                        console.error("Reset function is not available.");
                                                    }
                                                }}
                                                aria-label="Close"
                                                className="float-right cursor-pointer bg-none border-none"
                                            >
                                                &times;
                                            </button>
                                        </>
                                    }
                                    content={<p>{t("notifications.unsaved_data")}</p>}
                                    customContent={
                                        <>
                                            <ModalButton
                                                type="button"
                                                onClick={() => {
                                                    dispatch(clearBlocker());
                                                    if (blocker && typeof blocker.proceed === "function") {
                                                        blocker.proceed();
                                                    } else {
                                                        console.error("Proceed function is not available.");
                                                    }
                                                }}
                                            >
                                                {t("mainButtons.cancel")}
                                            </ModalButton>
                                            <ModalButton
                                                type="button"
                                                color="green"
                                                onClick={async () => {
                                                    dispatch(clearBlocker());
                                                    try {
                                                        await submitCreate(formik.values, formik.resetForm);
                                                        if (blocker && typeof blocker.proceed === "function") {
                                                            blocker.proceed();
                                                        }
                                                    } catch (error) {
                                                        console.error("Error saving data:", error);
                                                    }
                                                }}
                                            >
                                                {t("mainButtons.save")}
                                            </ModalButton>
                                        </>
                                    }
                                />
                            ) : null}
                            <ModalComponent
                                isOpen={errorModal}
                                onClose={() => setErrorModal(null)}
                                headerContent={t("notifications.modal_notification")}
                                content={
                                    <p>
                                        {`${t("errors.errors_list")}: ${errorModal?.errorMessage ? errorModal?.errorMessage : "ошибка."}`}
                                    </p>
                                }
                                customContent={
                                    <ModalButton type="button" onClick={() => setErrorModal(null)}>
                                        {t("mainButtons.accept")}
                                    </ModalButton>
                                }
                            />
                            {/* <ModalComponent
                                isOpen={userDelete !== null}
                                onClose={() => setUserDelete(null)}
                                headerContent={t("notifications.modal_notification")}
                                content={
                                    <p>
                                        {`Вы уверены что хотите удалить пользователя ${userDelete?.email}`}
                                    </p>
                                }
                                customContent={
                                    <>
                                        <ModalButton type="button" onClick={() => setUserDelete(null)}>
                                            {t("mainButtons.cancel")}
                                        </ModalButton>
                                        <ModalButton color="green" type="button" onClick={async () => {
                                            await deleteUser(userDelete?.userId); // Функция для удаления пользователя
                                            await fetchUsers();
                                            setUserDelete(null)
                                        }}>
                                            {t("mainButtons.accept")}
                                        </ModalButton>
                                    </>
                                }
                            /> */}

                            <div className="flex flex-col bg-white my-5 p-5 pt-8 relative rounded-xl shadow-md gap-[20px] overflow-visible">
                                <div
                                    className="flex items-center text-base text-gray-600 font-light gap-x-[10px] cursor-pointer pb-[20px] border-b-[2px]"
                                    onClick={() => setIsCreatePanelOpen(!isCreatePanelOpen)}
                                >
                                    <img src={"/icons/user-plus.svg"} className="w-[20px]" alt="icon" />
                                    <div className="uppercase">{t("systemReceiver.add_system_receiver")}</div>
                                    <div className={`ml-auto transform transition-transform duration-300 ${isCreatePanelOpen ? "rotate-180" : "rotate-0"}`}>
                                        <svg
                                            className="w-6 h-6"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                        </svg>
                                    </div>
                                </div>

                                <div className={`flex gap-[20px] flex-wrap ${isCreatePanelOpen ? "hidden" : ""}`}>
                                    <div className="flex items-center w-full pb-4 border-b border-gray-200 mb-2">
                                        <Switch
                                            checked={!!formik.values.useApiKey}
                                            onChange={(checked) => {
                                                formik.setFieldValue("useApiKey", checked);
                                                setIsFormChanged(true);
                                            }}
                                            name="useApiKey"
                                            id="useApiKey"
                                            label="Авторизация через API ключ"
                                        />
                                    </div>
                                    <div className={`w-[66%] gap-[20px] ${formik.values.useApiKey ? `grid grid-cols-2 ${style.gridApiLayout}` : "flex flex-wrap"}`}>
                                        <div className={style.inputField1}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <FieldLabel text={`${t("systemReceiver.name")}*`} />
                                                {formik.touched.name &&
                                                    formik.errors.name && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.name ===
                                                                    "string"
                                                                    ? formik.errors.name
                                                                    : t(
                                                                        "Ошибка",
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <Field
                                                type="text"
                                                name="name"
                                                placeholder={t("systemReceiver.choose_name")}
                                                className={style.placeholder}
                                                onChange={(e: any) => {
                                                    formik.handleChange(e);
                                                    // dispatch(setBlocker(true));
                                                    setIsFormChanged(true);
                                                }}
                                            />
                                        </div>

                                        {!!formik.values.useApiKey && (
                                    <>
                                        <div className={style.inputField1}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <FieldLabel text={`${t("systemReceiver.login_tnvd")}*`} />
                                                {formik.touched.loginAccessToken &&
                                                    formik.errors.loginAccessToken && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.loginAccessToken ===
                                                                    "string"
                                                                    ? formik.errors.loginAccessToken
                                                                    : t(
                                                                        "Ошибка",
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <Field
                                                type="text"
                                                name="loginAccessToken"
                                                placeholder={t("systemReceiver.login_tnvd_choose")}
                                                className={style.placeholder}
                                                onChange={(e: any) => {
                                                    formik.handleChange(e);
                                                    setIsFormChanged(true);
                                                }}
                                            />
                                        </div>

                                        <div className={style.inputField1}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <FieldLabel text={`${t("systemReceiver.password_tnvd")}*`} />
                                                {formik.touched.passwordAccessToken &&
                                                    formik.errors.passwordAccessToken && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.passwordAccessToken ===
                                                                    "string"
                                                                    ? formik.errors.passwordAccessToken
                                                                    : t(
                                                                        "Ошибка",
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    type="text"
                                                    name="passwordAccessToken"
                                                    placeholder={t("systemReceiver.password_tnvd_choose")}
                                                    className="placeholder"
                                                    onChange={(e: any) => {
                                                        formik.handleChange(e);
                                                        setIsFormChanged(true);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                            </>
                                        )}

                                        {!formik.values.useApiKey && (
                                            <>
                                        <div className={style.inputField1}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <FieldLabel text={`${t("systemReceiver.login_tnvd")}*`} />
                                                {formik.touched.urlTnvedGtinUsername &&
                                                    formik.errors.urlTnvedGtinUsername && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.urlTnvedGtinUsername ===
                                                                    "string"
                                                                    ? formik.errors.urlTnvedGtinUsername
                                                                    : t(
                                                                        "Ошибка",
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <Field
                                                type="text"
                                                name="urlTnvedGtinUsername"
                                                placeholder={t("systemReceiver.login_tnvd_choose")}
                                                className={style.placeholder}
                                                onChange={(e: any) => {
                                                    formik.handleChange(e);
                                                    setIsFormChanged(true);
                                                }}
                                            />
                                        </div>

                                        <div className={style.inputField1}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <FieldLabel text={`${t("systemReceiver.password_tnvd")}*`} />
                                                {formik.touched.urlTnvedGtinPassword &&
                                                    formik.errors.urlTnvedGtinPassword && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.urlTnvedGtinPassword ===
                                                                    "string"
                                                                    ? formik.errors.urlTnvedGtinPassword
                                                                    : t(
                                                                        "Ошибка",
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    type="text"
                                                    name="urlTnvedGtinPassword"
                                                    placeholder={t("systemReceiver.password_tnvd_choose")}
                                                    className="placeholder"
                                                    onChange={(e: any) => {
                                                        formik.handleChange(e);
                                                        setIsFormChanged(true);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                            </>
                                        )}

                                        <div className={style.inputField1}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <FieldLabel text={`${t("systemReceiver.url_tnvd")}*`} />
                                                {formik.touched.urlTnvedGtin &&
                                                    formik.errors.urlTnvedGtin && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.urlTnvedGtin ===
                                                                    "string"
                                                                    ? formik.errors.urlTnvedGtin
                                                                    : t(
                                                                        "Ошибка",
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    type="text"
                                                    name="urlTnvedGtin"
                                                    placeholder={t("systemReceiver.url_choose")}
                                                    className="placeholder"
                                                    onChange={(e: any) => {
                                                        formik.handleChange(e);
                                                        setIsFormChanged(true);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className={style.inputField1}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <FieldLabel text={`${t("systemReceiver.topik_name")}*`} />
                                                {formik.touched.autoTopicName &&
                                                    formik.errors.autoTopicName && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.autoTopicName ===
                                                                    "string"
                                                                    ? formik.errors.autoTopicName
                                                                    : t(
                                                                        "notification_from_third_countries.error_customs_clearance_reg_date",
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <div className="relative flex items-center">
                                                <Field
                                                    type="text"// Меняем тип на 'text', если показываем пароль
                                                    name="autoTopicName"
                                                    placeholder={t("systemReceiver.topik_name_choose")}
                                                    className="placeholder" // Ваш класс для стилей
                                                    onChange={(e: any) => {
                                                        formik.handleChange(e);
                                                        // dispatch(setBlocker(true));
                                                        setIsFormChanged(true);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className={style.inputField1}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <FieldLabel text={`${t("systemReceiver.group_name")}*`} />
                                                {formik.touched.ticketsTopicGroup &&
                                                    formik.errors.ticketsTopicGroup && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.ticketsTopicGroup ===
                                                                    "string"
                                                                    ? formik.errors.ticketsTopicGroup
                                                                    : t(
                                                                        "notification_from_third_countries.error_customs_clearance_reg_date",
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <Field
                                                type="text"
                                                name="ticketsTopicGroup"
                                                placeholder={t("systemReceiver.group_name_choose")}
                                                className="placeholder" // Ваш класс для стилей
                                                onChange={(e: any) => {
                                                    formik.handleChange(e);
                                                    // dispatch(setBlocker(true));
                                                    setIsFormChanged(true);
                                                }}
                                            />
                                        </div>

                                        <div className={style.inputField1}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <FieldLabel text={`${t("systemReceiver.url_check")}*`} />
                                                {formik.touched.url &&
                                                    formik.errors.url && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.url ===
                                                                    "string"
                                                                    ? formik.errors.url
                                                                    : t(
                                                                        "notification_from_third_countries.error_customs_clearance_reg_date",
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <Field
                                                type="text"
                                                name="url"
                                                placeholder={t("systemReceiver.url_check_choose")}
                                                className="placeholder"
                                                onChange={(e: any) => {
                                                    formik.handleChange(e);
                                                    setIsFormChanged(true);
                                                }}
                                            />
                                        </div>

                                        {!!formik.values.useApiKey && (
                                            <>
                                        <div className={style.inputField1}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <FieldLabel text={`${t("systemReceiver.url_get_access_token")}*`} />
                                                {formik.touched.urlGetAccessToken &&
                                                    formik.errors.urlGetAccessToken && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.urlGetAccessToken ===
                                                                    "string"
                                                                    ? formik.errors.urlGetAccessToken
                                                                    : t("Ошибка")}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <Field
                                                type="text"
                                                name="urlGetAccessToken"
                                                placeholder={t("systemReceiver.url_get_access_token_choose")}
                                                className="placeholder"
                                                onChange={(e: any) => {
                                                    formik.handleChange(e);
                                                    setIsFormChanged(true);
                                                }}
                                            />
                                        </div>

                                        <div className={style.inputField1}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <FieldLabel text={`${t("systemReceiver.url_refresh_token")}*`} />
                                                {formik.touched.urlRefreshToken &&
                                                    formik.errors.urlRefreshToken && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.urlRefreshToken ===
                                                                    "string"
                                                                    ? formik.errors.urlRefreshToken
                                                                    : t("Ошибка")}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <Field
                                                type="text"
                                                name="urlRefreshToken"
                                                placeholder={t("systemReceiver.url_refresh_token_choose")}
                                                className="placeholder"
                                                onChange={(e: any) => {
                                                    formik.handleChange(e);
                                                    setIsFormChanged(true);
                                                }}
                                            />
                                        </div>
                                            </>
                                        )}

                                        {!formik.values.useApiKey && (
                                        <div className={style.inputField1}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <FieldLabel text={`${t("systemReceiver.url_token")}*`} />
                                                {formik.touched.urlCheckAuth &&
                                                    formik.errors.urlCheckAuth && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.urlCheckAuth ===
                                                                    "string"
                                                                    ? formik.errors.urlCheckAuth
                                                                    : t(
                                                                        "notification_from_third_countries.error_customs_clearance_reg_date",
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <Field
                                                type="text"
                                                name="urlCheckAuth"
                                                placeholder={t("systemReceiver.url_token_choose")}
                                                className="placeholder"
                                                onChange={(e: any) => {
                                                    formik.handleChange(e);
                                                    setIsFormChanged(true);
                                                }}
                                            />
                                        </div>
                                        )}
                                    </div>

                                    {formik.values.useApiKey ? (
                                    <div className="flex flex-col gap-y-[20px] w-[32%]">
                                        <div className={`${style.inputField1} ${style.fullWidth}`}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <FieldLabel text="API ключ*" />
                                                {formik.touched.apiKey &&
                                                    formik.errors.apiKey && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.apiKey === "string"
                                                                    ? formik.errors.apiKey
                                                                    : t("Ошибка")}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <Field
                                                as="textarea"
                                                name="apiKey"
                                                placeholder="Вставьте API ключ"
                                                className={style.placeholder2}
                                                onChange={(e: any) => {
                                                    formik.handleChange(e);
                                                    setIsFormChanged(true);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    ) : (
                                    <div className="flex flex-col gap-y-[20px] w-[32%]">

                                        <div className={`${style.inputField1} ${style.fullWidth}`}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <FieldLabel text={`${t("ofd.publicKey")}*`} />
                                                {formik.touched.publicKey &&
                                                    formik.errors.publicKey && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.publicKey ===
                                                                    "string"
                                                                    ? formik.errors.publicKey
                                                                    : t(
                                                                        "Ошибка",
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <Field
                                                as="textarea"
                                                name="publicKey"
                                                placeholder={t("ofd.publicKey_choose")}
                                                className={style.placeholder2}
                                                onChange={(e: any) => {
                                                    formik.handleChange(e);
                                                    setIsFormChanged(true);
                                                }}
                                                onKeyDown={(e: React.KeyboardEvent) => {
                                                    if (e.key === " " || e.key === "Enter") {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </div>

                                        <div className={`${style.inputField1} ${style.fullWidth}`}>
                                            <div className={style.labelAndButtonWrapper}>
                                                <FieldLabel text={`${t("ofd.privateKey")}*`} />
                                                {formik.touched.privateKey &&
                                                    formik.errors.privateKey && (
                                                        <div className={style.tooltipWrapper}>
                                                            <FaExclamationCircle className={style.errorIcon} />
                                                            <div className={style.tooltipText}>
                                                                {typeof formik.errors.privateKey ===
                                                                    "string"
                                                                    ? formik.errors.privateKey
                                                                    : t(
                                                                        "Ошибка",
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <Field
                                                as="textarea"
                                                name="privateKey"
                                                placeholder={t("ofd.privateKey_choose")}
                                                className={style.placeholder2}
                                                onChange={(e: any) => {
                                                    formik.handleChange(e);
                                                    setIsFormChanged(true);
                                                }}
                                                onKeyDown={(e: React.KeyboardEvent) => {
                                                    if (e.key === " " || e.key === "Enter") {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </div>


                                    </div>
                                    )}

                                    <div className="ml-auto flex gap-[10px]">
                                        <button
                                            className="buttonEtrackc h-[40px] mb-[6px]  w-[200px] bg-mainColor hover:brightness-75 text-white font-bold py-2 px-4 rounded"
                                            type="submit"
                                        >

                                            {t("Создать")}

                                        </button>
                                        <button
                                            type="button"
                                            className="bg-bg w-auto text-gray-500 font-semibold py-2 px-4 h-[40px] rounded hover:brightness-75  whitespace-nowrap"
                                            onClick={() => {
                                                formik.resetForm()
                                            }}
                                        >
                                            {t("Отменить")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    );
                }}
            </Formik>

            <div className="w-full">
                <div className="rounded-lg overflow-x-auto bg-white">
                    <table className="max-w-full w-full leading-normal">
                        <thead className="border-b-2 border-gray-300">
                            <tr>

                                <th className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                    scope="col">
                                    {t("ID")}
                                </th>

                                <th
                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                    scope="col"
                                >
                                    {t("systemReceiver.name_receiver")}
                                </th>
                                <th
                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                    scope="col"
                                >
                                    {t("systemReceiver.url_check")}
                                </th>
                                <th
                                    className="px-5 py-3 text-center items-center text-gray-600 font-semibold bg-white border-b border-gray-200 flex justify-center"
                                    scope="col"
                                >
                                    {t("systemReceiver.add_date")}
                                    <div className="flex flex-col">
                                        <button className="h-6 w-6" onClick={toggleSort}>
                                            <img
                                                src={`/icons/arrow${sort === "ASC" ? "Down2" : "-top"}.svg`}
                                                className={`block h-6 w-6  ${sort === "ASC" ? "text-red-500" : ""}`}
                                                alt={sort === "ASC" ? "Ascending" : "Descending"}
                                            />
                                        </button>
                                    </div>
                                </th>
                                <th
                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                    scope="col"
                                >
                                    {t("systemReceiver.status")}
                                </th>
                                <th
                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                    scope="col"
                                >
                                    {t("systemReceiver.url_tnvd")}
                                </th>
                                <th
                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                    scope="col"
                                >
                                    {t("systemReceiver.tnvd_count")}
                                </th>
                                <th
                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                    scope="col"
                                >
                                    {t("")}
                                </th>
                            </tr>
                        </thead>
                        {isLoading ? (
                            <tbody>
                                <tr>
                                    <td colSpan={9} className="text-center py-10">
                                        <TableLoader />
                                    </td>
                                </tr>
                            </tbody>
                        ) : tableData?.consumers?.length === 0 || !tableData?.consumers ? (
                            <tbody>
                                <tr>
                                    <td colSpan={9} className="text-center py-5">
                                        <div>
                                            <EmptyListPlaceholderContent
                                                title={t("systemReceiver.not_found")}
                                                description={t("ofd.update_page")}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        ) : (
                            <tbody className="font-normal text-center">
                                {tableData?.consumers?.map((value: any, index: any) => (
                                    <>
                                        <tr
                                            key={`tr-${index}-${value.id}`}
                                            className="cursor-pointer hover:bg-gray-100"
                                            onClick={() => {
                                            }}
                                        >

                                            <td className="px-5 py-5 text-sm  border-b border-gray-200 text-gray-600">
                                                {value?.id || "-"}
                                            </td>

                                            <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                                                {value?.name || "-"}
                                            </td>
                                            <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 max-w-xs break-words">
                                                {value?.url || "-"}
                                            </td>
                                            <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                                                {value?.createdDateTime &&
                                                    format(value?.createdDateTime, "dd.MM.yyyy, HH:mm:ss") ||
                                                    "-"}
                                            </td>
                                            <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center w-[225px]">
                                                {value?.disabled != null ? (
                                                    !value.disabled ? (
                                                        <div className="flex justify-center">
                                                            <StatusBadge type="active">
                                                                {t("statusTypes.active")}
                                                            </StatusBadge>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <StatusBadge>
                                                                {t("statusTypes.not_active")}
                                                            </StatusBadge>
                                                        </>
                                                    )
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                            <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 max-w-xs break-words">
                                                {value?.urlTnvedGtin || "-"}
                                            </td>

                                            <td
                                                className={style.customTd}
                                                data-tooltip-id={`tooltip-${value?.id}`}
                                            >
                                                <div className="overflow-hidden text-overflow-ellipsis">
                                                    {value?.countTNVED || "0"}
                                                </div>
                                                <Tooltip
                                                    id={`tooltip-${value?.id}`}
                                                    place="top"
                                                    clickable={true}
                                                    className={style.customTooltip}
                                                >
                                                    <div className="flex flex-col">
                                                        <p style={{ margin: "8px 0 0" }}>
                                                            {value?.note || t("checks.no_note")}
                                                        </p>
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                navigator.clipboard.writeText(value?.note || '');
                                                                handleCopied()
                                                            }}
                                                            className="self-center bg-transparent text-gray-400 font-bold py-1 px-3 rounded cursor-pointer flex items-center gap-1 mt-1"
                                                        >
                                                            {copied ? (
                                                                <>
                                                                    <IoCheckmarkOutline />
                                                                    Скопировано!
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <FaRegCopy />
                                                                    Копировать
                                                                </>
                                                            )}
                                                        </button>
                                                    </div>
                                                </Tooltip>
                                            </td>
                                            <td className="px-5 py-5 text-sm  border-b border-gray-200 text-gray-600"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <ActionDropwdownCell
                                                    key={`cell-${index}-${value.id}-actions`}
                                                    id={value.id}
                                                    actions={renderActions(
                                                        value,
                                                        setErrorModal,
                                                        navigate,
                                                    )}
                                                    activeTooltipId={activeTooltipId}
                                                    onTooltipToggle={handleTooltipToggle}
                                                />
                                            </td>
                                        </tr>

                                    </>
                                ))}
                            </tbody>
                        )}
                    </table>
                </div>
                <Pagination
                    totalItems={tableData?.totalItems || 0}
                    totalPages={tableData?.totalPages || 0}
                    pagination={pagination}
                    setPagination={setPagination}
                />
            </div>

            <ModalComponent
                isOpen={!!isModalOpen}
                onClose={onModalClose}
                headerContent={
                    <h1 className="h__modal">{t("documentNotification.notification")}</h1>
                }
                content={
                    <p className="p__modal">
                        {t("documentLabels_3.confirm_delete")}
                        {Array.isArray(isModalOpen) && isModalOpen?.length > 1
                            ? t("documentLabels_3.selected_documents")
                            : t("documentLabels_3.selected_document")}
                        ?
                    </p>
                }
                customContent={
                    <div className="flex flex-row gap-[10px]">
                        <ModalButton
                            type="button"
                            color="grey"
                            onClick={() => {
                                setIsModalOpen(null);
                            }}
                        >
                            {t("mainButtons.cancel")}
                        </ModalButton>
                        <ModalButton
                            // color="green"
                            type="button"
                            onClick={async () => {
                                if (isModalOpen) {

                                }
                            }}
                        >
                            {t("mainButtons.delete")}
                        </ModalButton>
                    </div>
                }
            />
            {consumerEditModal ? (
                <ModalComponent
                    classNameModal='middleModalWidth'
                    isOpen={true}
                    onClose={() => {
                        setConsumerEditModal(null)
                    }}
                    headerContent={
                        <div className="flex justify-between">
                            <div className="flex items-center text-base text-gray-600 font-light gap-x-[10px] ">
                                <img src={"/icons/user-plus.svg"} className="w-[20px]" alt="icon" />
                                <div className="uppercase">{t("systemReceiver.system_editing")}</div>
                            </div>
                            <button
                                type="button"
                                onClick={() => {
                                    setConsumerEditModal(null)
                                }}
                                aria-label="Close"
                                className="float-right cursor-pointer bg-none border-none"
                            >
                                &times;
                            </button>
                        </div>
                    }
                    content={
                        <>
                            <Formik
                                initialValues={consumerEditModal}
                                onSubmit={(formikValues) => submitEdit(formikValues)}
                                enableReinitialize={true}
                                validateOnBlur={true}
                                validateOnChange={true}
                                validate={formValidate}
                            >
                                {(formik) => {
                                    const showErr = (field: string): boolean =>
                                        !!(((formik.touched as Record<string, unknown>)[field] || formik.submitCount > 0) && (formik.errors as Record<string, unknown>)[field]);
                                    return (
                                        <Form className=" w-full m-t-[20px]">
                                            <div className="flex flex-col bg-white my-5 p-5 pl-0 pr-0 pt-8 relative rounded-xl gap-[20px] overflow-visible">

                                                <div className="flex items-center w-full pb-4 border-b border-gray-200 mb-2">
                                                    <Switch
                                                        checked={!!formik.values.useApiKey}
                                                        onChange={(checked) => {
                                                            formik.setFieldValue("useApiKey", checked);
                                                            setIsFormChanged(true);
                                                        }}
                                                        name="useApiKey"
                                                        id="edit-useApiKey"
                                                        label="Авторизация через API ключ"
                                                        disabled={true}
                                                    />
                                                </div>

                                                <div className={`flex gap-[20px] flex-wrap ${formik.values.useApiKey ? `grid grid-cols-2 ${style.gridApiLayout}` : ""}`}>
                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("systemReceiver.name")}*`} />
                                                            {showErr("name") && (
                                                                    <div className={style.tooltipWrapper}>
                                                                        <FaExclamationCircle className={style.errorIcon} />
                                                                        <div className={style.tooltipText}>
                                                                            {typeof formik.errors.name === "string" ? formik.errors.name : t("Ошибка")}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <Field
                                                            type="text"
                                                            name="name"
                                                            placeholder={t("Введите имя")}
                                                            className={style.placeholder}
                                                            onChange={(e: any) => {
                                                                formik.handleChange(e);
                                                                setIsFormChanged(true);
                                                            }}
                                                        />
                                                    </div>

                                                    {!formik.values.useApiKey && (
                                                    <>
                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("systemReceiver.login_tnvd")}*`} />
                                                            {showErr("urlTnvedGtinUsername") && (
                                                                    <div className={style.tooltipWrapper}>
                                                                        <FaExclamationCircle className={style.errorIcon} />
                                                                        <div className={style.tooltipText}>{typeof formik.errors.urlTnvedGtinUsername === "string" ? formik.errors.urlTnvedGtinUsername : t("Ошибка")}</div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <Field
                                                            type="text"
                                                            name="urlTnvedGtinUsername"
                                                            placeholder={t("systemReceiver.login_tnvd_choose")}
                                                            className={style.placeholder}
                                                            onChange={(e: any) => { formik.handleChange(e); setIsFormChanged(true); }}
                                                        />
                                                    </div>

                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("systemReceiver.password_tnvd")}*`} />
                                                            {showErr("urlTnvedGtinPassword") && (
                                                                    <div className={style.tooltipWrapper}>
                                                                        <FaExclamationCircle className={style.errorIcon} />
                                                                        <div className={style.tooltipText}>{typeof formik.errors.urlTnvedGtinPassword === "string" ? formik.errors.urlTnvedGtinPassword : t("Ошибка")}</div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <div className="relative flex items-center">
                                                            <Field type="text" name="urlTnvedGtinPassword" placeholder={t("systemReceiver.password_tnvd_choose")} className="placeholder" onChange={(e: any) => { formik.handleChange(e); setIsFormChanged(true); }} />
                                                        </div>
                                                    </div>

                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("systemReceiver.url_tnvd")}*`} />
                                                            {showErr("urlTnvedGtin") && (
                                                                    <div className={style.tooltipWrapper}>
                                                                        <FaExclamationCircle className={style.errorIcon} />
                                                                        <div className={style.tooltipText}>{typeof formik.errors.urlTnvedGtin === "string" ? formik.errors.urlTnvedGtin : t("Ошибка")}</div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <div className="relative flex items-center">
                                                            <Field type="text" name="urlTnvedGtin" placeholder={t("systemReceiver.url_choose")} className="placeholder" onChange={(e: any) => { formik.handleChange(e); setIsFormChanged(true); }} />
                                                        </div>
                                                    </div>

                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("systemReceiver.url_check")}*`} />
                                                            {showErr("url") && (
                                                                    <div className={style.tooltipWrapper}>
                                                                        <FaExclamationCircle className={style.errorIcon} />
                                                                        <div className={style.tooltipText}>{typeof formik.errors.url === "string" ? formik.errors.url : t("Ошибка")}</div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <Field type="text" name="url" placeholder={t("systemReceiver.url_check_choose")} className="placeholder" onChange={(e: any) => { formik.handleChange(e); setIsFormChanged(true); }} />
                                                    </div>

                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("systemReceiver.url_token")}*`} />
                                                            {showErr("urlCheckAuth") && (
                                                                    <div className={style.tooltipWrapper}>
                                                                        <FaExclamationCircle className={style.errorIcon} />
                                                                        <div className={style.tooltipText}>{typeof formik.errors.urlCheckAuth === "string" ? formik.errors.urlCheckAuth : t("Ошибка")}</div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <Field type="text" name="urlCheckAuth" placeholder={t("systemReceiver.url_token_choose")} className="placeholder" onChange={(e: any) => { formik.handleChange(e); setIsFormChanged(true); }} />
                                                    </div>

                                                    <div className={`${style.inputField1} ${style.fullWidth}`}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("ofd.publicKey")}*`} />
                                                            {showErr("publicKey") && (
                                                                    <div className={style.tooltipWrapper}>
                                                                        <FaExclamationCircle className={style.errorIcon} />
                                                                        <div className={style.tooltipText}>
                                                                            {typeof formik.errors.publicKey ===
                                                                                "string"
                                                                                ? formik.errors.publicKey
                                                                                : t(
                                                                                    "Ошибка",
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <Field
                                                            as="textarea"
                                                            name="publicKey"
                                                            placeholder={t("Вставьте публичный ключ")}
                                                            className={style.placeholder2}
                                                            onChange={(e: any) => {
                                                                formik.handleChange(e);
                                                                // dispatch(setBlocker(true));
                                                                setIsFormChanged(true);
                                                            }}
                                                            onKeyDown={(e: React.KeyboardEvent) => {
                                                                // Запрещаем пробелы и Enter
                                                                if (e.key === " " || e.key === "Enter") {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                    </div>

                                                    <div className={`${style.inputField1} ${style.fullWidth}`}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("ofd.privateKey")}*`} />
                                                            {showErr("privateKey") && (
                                                                    <div className={style.tooltipWrapper}>
                                                                        <FaExclamationCircle className={style.errorIcon} />
                                                                        <div className={style.tooltipText}>{typeof formik.errors.privateKey === "string" ? formik.errors.privateKey : t("Ошибка")}</div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <Field as="textarea" name="privateKey" placeholder={t("ofd.privateKey_choose")} className={style.placeholder2} onChange={(e: any) => { formik.handleChange(e); setIsFormChanged(true); }} onKeyDown={(e: React.KeyboardEvent) => { if (e.key === " " || e.key === "Enter") e.preventDefault(); }} />
                                                    </div>
                                                    </>
                                                    )}

                                                    {!!formik.values.useApiKey && (
                                                    <>
                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("systemReceiver.login_tnvd")}*`} />
                                                            {showErr("loginAccessToken") && (
                                                                <div className={style.tooltipWrapper}>
                                                                    <FaExclamationCircle className={style.errorIcon} />
                                                                    <div className={style.tooltipText}>{typeof formik.errors.loginAccessToken === "string" ? formik.errors.loginAccessToken : t("Ошибка")}</div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <Field type="text" name="loginAccessToken" placeholder={t("systemReceiver.login_tnvd_choose")} className={style.placeholder} onChange={(e: any) => { formik.handleChange(e); setIsFormChanged(true); }} />
                                                    </div>
                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("systemReceiver.password_tnvd")}*`} />
                                                            {showErr("passwordAccessToken") && (
                                                                <div className={style.tooltipWrapper}>
                                                                    <FaExclamationCircle className={style.errorIcon} />
                                                                    <div className={style.tooltipText}>{typeof formik.errors.passwordAccessToken === "string" ? formik.errors.passwordAccessToken : t("Ошибка")}</div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <Field type="text" name="passwordAccessToken" placeholder={t("systemReceiver.password_tnvd_choose")} className="placeholder" onChange={(e: any) => { formik.handleChange(e); setIsFormChanged(true); }} />
                                                    </div>
                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("systemReceiver.url_tnvd")}*`} />
                                                            {showErr("urlTnvedGtin") && (
                                                                <div className={style.tooltipWrapper}>
                                                                    <FaExclamationCircle className={style.errorIcon} />
                                                                    <div className={style.tooltipText}>{typeof formik.errors.urlTnvedGtin === "string" ? formik.errors.urlTnvedGtin : t("Ошибка")}</div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <Field type="text" name="urlTnvedGtin" placeholder={t("systemReceiver.url_choose")} className="placeholder" onChange={(e: any) => { formik.handleChange(e); setIsFormChanged(true); }} />
                                                    </div>
                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("systemReceiver.url_check")}*`} />
                                                            {showErr("url") && (
                                                                <div className={style.tooltipWrapper}>
                                                                    <FaExclamationCircle className={style.errorIcon} />
                                                                    <div className={style.tooltipText}>
                                                                        {typeof formik.errors.url === "string" ? formik.errors.url : t("Ошибка")}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <Field
                                                            type="text"
                                                            name="url"
                                                            placeholder={t("systemReceiver.url_check_choose")}
                                                            className={style.placeholder}
                                                            onChange={(e: any) => { formik.handleChange(e); setIsFormChanged(true); }}
                                                        />
                                                    </div>
                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("systemReceiver.url_get_access_token")}*`} />
                                                            {showErr("urlGetAccessToken") && (
                                                                <div className={style.tooltipWrapper}>
                                                                    <FaExclamationCircle className={style.errorIcon} />
                                                                    <div className={style.tooltipText}>{typeof formik.errors.urlGetAccessToken === "string" ? formik.errors.urlGetAccessToken : t("Ошибка")}</div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <Field type="text" name="urlGetAccessToken" placeholder={t("systemReceiver.url_get_access_token_choose")} className={style.placeholder} onChange={(e: any) => { formik.handleChange(e); setIsFormChanged(true); }} />
                                                    </div>
                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("systemReceiver.url_refresh_token")}*`} />
                                                            {showErr("urlRefreshToken") && (
                                                                <div className={style.tooltipWrapper}>
                                                                    <FaExclamationCircle className={style.errorIcon} />
                                                                    <div className={style.tooltipText}>{typeof formik.errors.urlRefreshToken === "string" ? formik.errors.urlRefreshToken : t("Ошибка")}</div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <Field type="text" name="urlRefreshToken" placeholder={t("systemReceiver.url_refresh_token_choose")} className={style.placeholder} onChange={(e: any) => { formik.handleChange(e); setIsFormChanged(true); }} />
                                                    </div>
                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("systemReceiver.topik_name")}*`} />
                                                            {showErr("autoTopicName") && (
                                                                <div className={style.tooltipWrapper}>
                                                                    <FaExclamationCircle className={style.errorIcon} />
                                                                    <div className={style.tooltipText}>{typeof formik.errors.autoTopicName === "string" ? formik.errors.autoTopicName : t("Ошибка")}</div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <Field type="text" name="autoTopicName" placeholder={t("systemReceiver.topik_name_choose")} className={style.placeholder} disabled onChange={(e: any) => { formik.handleChange(e); setIsFormChanged(true); }} />
                                                    </div>
                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("systemReceiver.group_name")}*`} />
                                                            {showErr("ticketsTopicGroup") && (
                                                                <div className={style.tooltipWrapper}>
                                                                    <FaExclamationCircle className={style.errorIcon} />
                                                                    <div className={style.tooltipText}>{typeof formik.errors.ticketsTopicGroup === "string" ? formik.errors.ticketsTopicGroup : t("Ошибка")}</div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <Field type="text" name="ticketsTopicGroup" placeholder={t("systemReceiver.group_name_choose")} className={style.placeholder} disabled onChange={(e: any) => { formik.handleChange(e); setIsFormChanged(true); }} />
                                                    </div>
                                                    <div className={`${style.inputField1} ${style.fullWidth}`}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text="API ключ*" />
                                                            {showErr("apiKey") && (
                                                                <div className={style.tooltipWrapper}>
                                                                    <FaExclamationCircle className={style.errorIcon} />
                                                                    <div className={style.tooltipText}>{typeof formik.errors.apiKey === "string" ? formik.errors.apiKey : t("Ошибка")}</div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <Field as="textarea" name="apiKey" placeholder="Вставьте API ключ" className={style.placeholder2} onChange={(e: any) => { formik.handleChange(e); setIsFormChanged(true); }} />
                                                    </div>
                                                    </>
                                                    )}

                                                    <div className={`${style.inputField1} max-w-[calc(50%-10px)]`}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <FieldLabel text={`${t("Статус")}*`} />
                                                            {showErr("disabled") && (
                                                                    <div className={style.tooltipWrapper}>
                                                                        <FaExclamationCircle className={style.errorIcon} />
                                                                        <div className={style.tooltipText}>{typeof formik.errors.disabled === "string" ? formik.errors.disabled : t("Ошибка")}</div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <Field
                                                            component={SelectCustomFormik}
                                                            name="disabled"
                                                            placeholder={t("Выберите статус")}
                                                            options={[
                                                                { value: true, label: 'Заблокирован' },
                                                                { value: false, label: 'Активный' },
                                                            ]}
                                                            isMulti={false}
                                                            menuPlacement="top"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex justify-end gap-[10px]">
                                                <ModalButton
                                                    type="button"
                                                    onClick={() => {
                                                        dispatch(clearBlocker());
                                                        if (blocker && typeof blocker.proceed === "function") {
                                                            blocker.proceed();
                                                        } else {
                                                            console.error("Proceed function is not available.");
                                                        }
                                                        setConsumerEditModal(null)
                                                    }}
                                                >
                                                    {t("mainButtons.cancel")}
                                                </ModalButton>
                                                <ModalButton
                                                    type="submit"
                                                    color="green"
                                                    onClick={async () => {
                                                        dispatch(clearBlocker());
                                                        try {

                                                            if (blocker && typeof blocker.proceed === "function") {
                                                                blocker.proceed();
                                                            }
                                                        } catch (error) {
                                                            console.error("Error saving data:", error);
                                                        }
                                                    }}
                                                >
                                                    {t("mainButtons.save")}
                                                </ModalButton>
                                            </div>
                                        </Form>
                                    );
                                }}
                            </Formik>
                        </>
                    }
                    customContent={
                        <>
                        </>
                    }
                />
            ) : null}
            <ModalComponent
                isOpen={!!(failedModal && failedModal.length > 0)}
                onClose={onModalClose}
                headerContent={
                    <h1 className="h__modal">{t("documentNotification.notification")}</h1>
                }
                content={
                    <p className="p__modal ">
                        У следующих документов обнаружен неправильный статус:
                        <ul>
                            {failedModal?.map((item, index) => (
                                <li key={index} className="underline-offset-4">{item}</li>
                            ))}
                        </ul>

                    </p>
                }
                customContent={
                    <div className="flex flex-row gap-[10px]">
                        <ModalButton
                            type="button"
                            color="grey"
                            onClick={() => {
                                setFailedModal([])
                            }}
                        >
                            {t("mainButtons.continue")}
                        </ModalButton>

                    </div>
                }
            />

            <ModalComponent
                isOpen={сreateTNVDModal}
                onClose={() => {
                    setCreateTNVDModal(false);
                    resetTnvedImportState();
                }}
                headerContent={
                    <h1 className="h__modal">
                        Добавление привязки получателя к ТНВЭД
                    </h1>
                }
                content={
                    <>
                        <Formik
                            initialValues={createValues}
                            onSubmit={(formikValues) => {
                                if (tnvedImportFile) {
                                    if (!formikValues.consumerId) {
                                        setAlertOpen({
                                            status: "error",
                                            message: "Выберите систему получателя",
                                        });
                                        return;
                                    }

                                    importTNVEDFromFile(
                                        tnvedImportFile,
                                        Number(formikValues.consumerId),
                                        formikValues.groupNameId != null
                                            ? Number(formikValues.groupNameId)
                                            : null
                                    )
                                        .then((result) => {
                                            if (initialValues.consumerId === formikValues.consumerId) {
                                                submitTNVD(formikValues);
                                            }

                                            setCreateTNVDModal(false);
                                            resetTnvedImportState();
                                            openTnvedImportResult(result || {});
                                        })
                                        .catch((error) => {
                                            const errorData = error.response?.data;
                                            if (
                                                errorData &&
                                                (Array.isArray(errorData.duplicateCodes) ||
                                                    typeof errorData.addedCount === "number")
                                            ) {
                                                setCreateTNVDModal(false);
                                                resetTnvedImportState();
                                                openTnvedImportResult(errorData);
                                                return;
                                            }

                                            setAlertOpen({
                                                status: "error",
                                                message:
                                                    errorData?.message ||
                                                    "Ошибка при импорте ТН ВЭД из файла",
                                            });
                                        });
                                    return;
                                }

                                createTNVDCode({
                                    code: formikValues.code,
                                    consumerId: formikValues.consumerId,
                                    groupNameId: formikValues.groupNameId,
                                })
                                    .then(() => {
                                        if (initialValues.consumerId === formikValues.consumerId) {
                                            submitTNVD(formikValues);
                                        }

                                        setAlertOpen({
                                            status: "SUCCESS",
                                            message: "ТН ВЭД код успешно создан",
                                        });
                                        setCreateTNVDModal(false);
                                        resetTnvedImportState();
                                    })
                                    .catch((error) => {
                                        setAlertOpen({
                                            status: "error",
                                            message: error.response?.data?.message || "Ошибка при создании ТН ВЭД кода",
                                        });
                                    });
                            }}

                            enableReinitialize={true}
                            validateOnBlur={true}
                            validateOnChange={true}
                            validationSchema={minCodeSchema(true, !!tnvedImportFile)}
                        >
                            {(formik) => {
                                return (
                                    <Form className="w-full m-t-[20px]">
                                        <div className="flex flex-col bg-white my-5 p-5 pl-0 pr-0 pt-8 relative rounded-xl gap-[20px] overflow-visible">
                                            <div className="flex flex-col items-center gap-[20px] flex-wrap">
                                                <div className={`${style.inputField1} !max-w-[300px]`}>
                                                    <div className={style.labelAndButtonWrapper}>
                                                        <FieldLabel
                                                            text={
                                                                tnvedImportFile
                                                                    ? t("Файл с кодами ТНВЭД")
                                                                    : `${t("Код ТНВЭД")}*`
                                                            }
                                                        />
                                                        {!tnvedImportFile &&
                                                            formik.touched.code &&
                                                            formik.errors.code && (
                                                            <div className={style.tooltipWrapper}>
                                                                <FaExclamationCircle className={style.errorIcon} />
                                                                <div className={style.tooltipText}>
                                                                    {typeof formik.errors.code === "string"
                                                                        ? formik.errors.code
                                                                        : t("Ошибка")}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {tnvedImportFile ? (
                                                        <div className={style.tnvedFileChip}>
                                                            <span className={style.tnvedFileName} title={tnvedImportFile.name}>
                                                                {tnvedImportFile.name}
                                                            </span>
                                                            <button
                                                                type="button"
                                                                className={style.tnvedFileClear}
                                                                onClick={() => {
                                                                    setTnvedImportFile(null);
                                                                    setTnvedTempFile(null);
                                                                    if (tnvedFileInputRef.current) {
                                                                        tnvedFileInputRef.current.value = "";
                                                                    }
                                                                    formik.setFieldValue("code", "");
                                                                }}
                                                                aria-label="Удалить файл"
                                                            >
                                                                ✕
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div className={style.tnvedCodeInputWrap}>
                                                            <Field
                                                                type="text"
                                                                name="code"
                                                                placeholder={t("Введите код")}
                                                                className={`${style.placeholder} ${style.tnvedCodeInput}`}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                    const value = e.target.value.replace(/\D/g, "").slice(0, 10)
                                                                    formik.setFieldValue("code", value)
                                                                    setIsFormChanged(true)
                                                                }}
                                                            />
                                                            <button
                                                                type="button"
                                                                className={style.tnvedUploadLink}
                                                                onClick={openTnvedUploadModal}
                                                            >
                                                                загрузить из файла
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>

                                                <div className={`${style.inputField} !max-w-[300px]`}>
                                                    <div className={style.labelAndButtonWrapper}>
                                                        <FieldLabel text={t("Система получателя")} />
                                                    </div>
                                                    <Field
                                                        value={formik.values.consumerId || null}
                                                        component={SelectCustomFormik}
                                                        name="consumerId"
                                                        isClearable={true}
                                                        placeholder={t("Выберите систему получателя")}
                                                        size="dm"
                                                        options={consumerList}
                                                        onChange={(options: any) => {
                                                            formik.setFieldValue("consumerId", options);
                                                            formik.setFieldValue("consumerIdNumber", options || "");
                                                        }}
                                                    />
                                                </div>

                                                <div className={`${style.inputField} !max-w-[300px]`}>
                                                    <div className={style.labelAndButtonWrapper}>
                                                        <FieldLabel text={t("Система получателя Id")} />
                                                    </div>
                                                    <Field
                                                        type="text"
                                                        disabled={true}
                                                        name="consumerIdNumber"
                                                        placeholder="Заполняется автоматически"
                                                        className={style.placeholder}


                                                    />
                                                </div>

                                                <div className={`${style.inputField} !max-w-[300px] !mb-[60px]`}>
                                                    <div className={style.labelAndButtonWrapper}>
                                                        <FieldLabel text={t("Группа")} />
                                                    </div>
                                                    <Field
                                                        value={formik.values.groupNameId || null}
                                                        component={SelectCustomFormik}
                                                        name="groupNameId"
                                                        isClearable={true}
                                                        placeholder="Выберите группу товара"
                                                        size="dm"
                                                        options={groupList}
                                                        onChange={(options: any) => {
                                                            formik.setFieldValue("groupNameId", options);
                                                        }}
                                                    />
                                                </div>
                                                <div className="flex gap-[10px]">
                                                    <ModalButton
                                                        type="button"
                                                        onClick={() => {
                                                            dispatch(clearBlocker());
                                                            if (blocker && typeof blocker.proceed === "function") {
                                                                blocker.proceed();
                                                            } else {
                                                                console.error("Proceed function is not available.");
                                                            }
                                                            setCreateTNVDModal(false)
                                                            resetTnvedImportState()
                                                        }}
                                                    >
                                                        {t("mainButtons.cancel")}
                                                    </ModalButton>
                                                    <ModalButton
                                                        type="submit"
                                                        color="green"
                                                        onClick={async () => {
                                                            dispatch(clearBlocker());
                                                            try {

                                                                if (blocker && typeof blocker.proceed === "function") {
                                                                    blocker.proceed();
                                                                }
                                                            } catch (error) {
                                                                console.error("Error saving data:", error);
                                                            }
                                                        }}
                                                    >
                                                        {t("Прикрепить")}
                                                    </ModalButton>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                );
                            }}
                        </Formik>
                    </>
                }
                customContent={
                    <>
                    </>
                }
            />

            <ModalComponent
                isOpen={isTnvedUploadModalOpen}
                onClose={() => {
                    setIsTnvedUploadModalOpen(false);
                    setTnvedTempFile(tnvedImportFile);
                    setIsTnvedDragActive(false);
                }}
                classNameOverlay={style.tnvedUploadOverlay}
                headerContent={
                    <h1 className="h__modal">Загрузка файла Excel</h1>
                }
                content={
                    <div className="w-full flex flex-col gap-4 mt-3">
                        <p className="text-sm text-[#678aa1]">
                            Коды должны находиться в первом столбце первого листа. Допустимы только файлы Excel (.xlsx, .xls).
                        </p>

                        <input
                            ref={tnvedFileInputRef}
                            type="file"
                            accept={EXCEL_ACCEPT}
                            onChange={(e) => {
                                handleTnvedFileSelect(e.target.files?.[0]);
                                e.target.value = "";
                            }}
                            className="hidden"
                        />

                        <div
                            onDragOver={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                setIsTnvedDragActive(true);
                            }}
                            onDragLeave={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                setIsTnvedDragActive(false);
                            }}
                            onDrop={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                setIsTnvedDragActive(false);
                                handleTnvedFileSelect(event.dataTransfer.files?.[0]);
                            }}
                            onClick={() => tnvedFileInputRef.current?.click()}
                            className={`${style.tnvedDropZone} ${
                                isTnvedDragActive ? style.tnvedDropZoneActive : ""
                            }`}
                        >
                            <p className="text-sm font-medium text-[#2e3138]">
                                Перетащите Excel-файл сюда или нажмите для выбора
                            </p>
                            <p className="text-xs text-[#678aa1] mt-1">
                                Поддерживаемые форматы: .xlsx, .xls
                            </p>
                            {tnvedTempFile ? (
                                <div className={style.tnvedDropFileRow}>
                                    <span className={style.tnvedFileName} title={tnvedTempFile.name}>
                                        {tnvedTempFile.name}
                                    </span>
                                    <button
                                        type="button"
                                        className={style.tnvedFileClear}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setTnvedTempFile(null);
                                            if (tnvedFileInputRef.current) {
                                                tnvedFileInputRef.current.value = "";
                                            }
                                        }}
                                        aria-label="Очистить файл"
                                    >
                                        ✕
                                    </button>
                                </div>
                            ) : (
                                <p className="text-sm text-mainColor mt-3">Файл не выбран</p>
                            )}
                        </div>
                    </div>
                }
                customContent={
                    <div className="flex gap-[10px]">
                        <ModalButton
                            type="button"
                            onClick={() => {
                                setIsTnvedUploadModalOpen(false);
                                setTnvedTempFile(tnvedImportFile);
                                setIsTnvedDragActive(false);
                            }}
                        >
                            {t("mainButtons.cancel")}
                        </ModalButton>
                        <ModalButton
                            type="button"
                            color="green"
                            onClick={applyTnvedTempFile}
                        >
                            Выбрать
                        </ModalButton>
                    </div>
                }
            />

            <ModalComponent
                isOpen={!!tnvedImportResult}
                onClose={() => setTnvedImportResult(null)}
                classNameOverlay={style.tnvedUploadOverlay}
                headerContent={
                    <h1 className="h__modal">Результат импорта ТНВЭД</h1>
                }
                content={
                    tnvedImportResult ? (
                        <div className={style.tnvedImportResult}>
                            <p className={style.tnvedImportMessage}>
                                {tnvedImportResult.message || "Импорт завершён"}
                            </p>
                            <div className={style.tnvedImportStats}>
                                <div className={style.tnvedImportStatItem}>
                                    <span className={style.tnvedImportStatLabel}>Добавлено</span>
                                    <span className={style.tnvedImportStatValue}>
                                        {tnvedImportResult.addedCount ?? 0}
                                    </span>
                                </div>
                                <div className={style.tnvedImportStatItem}>
                                    <span className={style.tnvedImportStatLabel}>Дубликаты</span>
                                    <span className={style.tnvedImportStatValue}>
                                        {tnvedImportResult.duplicateCodes?.length ?? 0}
                                    </span>
                                </div>
                            </div>

                            {(tnvedImportResult.duplicateCodes?.length ?? 0) > 0 && (
                                <div className={style.tnvedDupBlock}>
                                    <div className={style.tnvedDupTitle}>Дублирующиеся коды</div>
                                    <div className={style.tnvedDupTableWrap}>
                                        <table className={style.tnvedDupTable}>
                                            <thead>
                                                <tr>
                                                    <th>№</th>
                                                    <th>Код ТНВЭД</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(tnvedImportResult.duplicateCodes || [])
                                                    .slice(
                                                        tnvedDupPageIndex * TNVED_DUP_PAGE_SIZE,
                                                        tnvedDupPageIndex * TNVED_DUP_PAGE_SIZE +
                                                            TNVED_DUP_PAGE_SIZE
                                                    )
                                                    .map((code, index) => (
                                                        <tr key={`${code}-${index}`}>
                                                            <td>
                                                                {tnvedDupPageIndex * TNVED_DUP_PAGE_SIZE +
                                                                    index +
                                                                    1}
                                                            </td>
                                                            <td>{code}</td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    {(tnvedImportResult.duplicateCodes?.length ?? 0) >
                                        TNVED_DUP_PAGE_SIZE && (
                                        <div className={style.tnvedDupPagination}>
                                            <button
                                                type="button"
                                                className={style.tnvedDupPageBtn}
                                                disabled={tnvedDupPageIndex === 0}
                                                onClick={() =>
                                                    setTnvedDupPageIndex((prev) =>
                                                        Math.max(0, prev - 1)
                                                    )
                                                }
                                            >
                                                ‹
                                            </button>
                                            <span className={style.tnvedDupPageInfo}>
                                                {tnvedDupPageIndex + 1} /{" "}
                                                {Math.ceil(
                                                    (tnvedImportResult.duplicateCodes?.length || 0) /
                                                        TNVED_DUP_PAGE_SIZE
                                                )}
                                            </span>
                                            <button
                                                type="button"
                                                className={style.tnvedDupPageBtn}
                                                disabled={
                                                    tnvedDupPageIndex >=
                                                    Math.ceil(
                                                        (tnvedImportResult.duplicateCodes?.length ||
                                                            0) / TNVED_DUP_PAGE_SIZE
                                                    ) -
                                                        1
                                                }
                                                onClick={() =>
                                                    setTnvedDupPageIndex((prev) => prev + 1)
                                                }
                                            >
                                                ›
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    ) : null
                }
                customContent={
                    <ModalButton
                        type="button"
                        color="green"
                        onClick={() => setTnvedImportResult(null)}
                    >
                        Принять
                    </ModalButton>
                }
            />


            <ModalComponent
                isOpen={checkModal}
                onClose={() => {
                    setCheckModal(null);
                }}
                headerContent={
                    <h1 className="h__modal">
                        Чек
                    </h1>
                }
                content={
                    <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                        {JSON.stringify(checkModal, null, 2)}
                    </pre>
                }
                customContent={

                    <ModalButton
                        type="button"
                        color='green'
                        onClick={() => {
                            setCheckModal(null);
                        }}
                    >
                        Принять
                    </ModalButton>
                }
            />

            <ModalComponent
                isOpen={errorModal
                    // && !errorModal.singleError
                }
                onClose={() => {
                    setErrorModal(null);
                }}
                headerContent={
                    <h1 className="h__modal">
                        {t("documentNotification.notification")}
                    </h1>
                }
                content={
                    //   <div className="error-list">
                    //   <ul>
                    //     {errorModal && errorModal?.length > 0 ? (
                    //       errorModal.map((error: any, index: any) => (
                    //         <li className="border-b border-gray-300 py-1" key={index}>
                    //           {t(`error_dictionary.${error}`)}
                    //         </li>
                    //       ))
                    //     ) : (
                    //       <li>{t("documentNotification.no_errors")}</li>
                    //     )}
                    //   </ul>
                    // </div>

                    <div className="error-list">
                        <ul>
                            {Array.isArray(errorModal) && errorModal.length > 0 ? (
                                errorModal.map((error: any, index: number) => {
                                    console.log("Error data:", error);

                                    // Если error — это объект, извлекаем ключи или значения
                                    const errorText = typeof error === "object" ? JSON.stringify(error) : error;

                                    return (
                                        <li className="border-b border-gray-300 py-1" key={index}>
                                            Ошибка:  {t(`error_dictionary.${errorText}`)}
                                        </li>
                                    );
                                })
                            ) : typeof errorModal === "object" && errorModal !== null ? (
                                // Обработка случая, когда errorModal является объектом
                                errorModal.errorMessage ? (
                                    <li className="border-b border-gray-300 py-1">
                                        {t('documentStatus.error')}: {errorModal.errorMessage}
                                    </li>
                                ) : (
                                    <li>{t("documentNotification.no_errors")}</li>
                                )
                            ) : (
                                <li>{t("documentNotification.no_errors")}</li>
                            )}
                        </ul>
                    </div>
                }
                customContent={
                    <ModalButton
                        type="button"
                        onClick={() => {
                            setErrorModal(null);
                        }}
                    >
                        {t("mainButtons.accept")}
                    </ModalButton>
                }
            />
            <ModalComponent
                isOpen={unlinkConsumer !== null}
                onClose={() => setUnlinkConsumer(null)}
                headerContent={t("notifications.modal_notification")}
                content={
                    <p>
                        {`Вы уверены что хотите отвязать ТНВЭД ${unlinkConsumer?.code}`}
                    </p>
                }
                customContent={
                    <>
                        <ModalButton type="button" onClick={() => setUnlinkConsumer(null)}>
                            {t("mainButtons.cancel")}
                        </ModalButton>
                        <ModalButton color="green" type="button" onClick={async () => {
                            unlinkConsumerFromTNVED(unlinkConsumer?.code, unlinkConsumer?.consumerId)
                                .then((data) => {
                                    submitTNVD(unlinkConsumer)
                                    if(initialValues.code == unlinkConsumer?.code){
                                       setTnvdData([]) 
                                    }
                                    setAlertOpen({
                                        status: "SUCCESS",
                                        message: "Получатель успешно откреплён от ТН ВЭД",
                                    });
                                })
                                .catch((error) => {
                                    setAlertOpen({
                                        status: "error",
                                        message: error.response?.data?.message || "Ошибка при откреплении",
                                    });
                                });
                            setUnlinkConsumer(null)
                        }}>
                            {t("mainButtons.accept")}
                        </ModalButton>
                    </>
                }
            />
            <AlertBox isOpen={alertOpen} setIsOpen={setAlertOpen} />
        </div>
    );
};

export default SystemReceiver;
